"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiReducer = exports.InvalidActionTypeError = exports.createApiInitialState = void 0;
const types_1 = require("../../../types");
const apiActions_1 = require("./apiActions");
const createApiInitialState = (state) => (Object.assign(Object.assign({}, state), { error: null, loading: false, resolved: false }));
exports.createApiInitialState = createApiInitialState;
class InvalidActionTypeError extends Error {
    constructor(type) {
        super(`Unknown action type. Type: ${type}`);
    }
}
exports.InvalidActionTypeError = InvalidActionTypeError;
const createApiReducer = (initialState) => {
    const composedInitialState = (0, exports.createApiInitialState)(initialState);
    return {
        initialState: composedInitialState,
        reducer: (state = composedInitialState, action) => {
            switch (action.type) {
                case types_1.ApiActionTypeEnum.IDLE:
                    return Object.assign({}, state);
                case types_1.ApiActionTypeEnum.CALL_API:
                    return Object.assign(Object.assign({}, state), { loading: true, resolved: false });
                case types_1.ApiActionTypeEnum.RESOLVED:
                    return Object.assign(Object.assign(Object.assign({}, state), action.payload), { error: null, loading: false, resolved: true });
                case types_1.ApiActionTypeEnum.REJECTED:
                    return Object.assign(Object.assign({}, state), { error: action.error, loading: false, resolved: false });
                default:
                    throw new InvalidActionTypeError(action.type);
            }
        },
        actions: {
            idle: (apiActions_1.apiIdleAction),
            callApi: (apiActions_1.apiCallApiAction),
            resolve: (apiActions_1.apiResolveAction),
            reject: (apiActions_1.apiRejectAction),
        },
    };
};
exports.createApiReducer = createApiReducer;
